import { render, staticRenderFns } from "./EnterPasswordResetCode.vue?vue&type=template&id=04897481&scoped=true&"
import script from "./EnterPasswordResetCode.vue?vue&type=script&lang=js&"
export * from "./EnterPasswordResetCode.vue?vue&type=script&lang=js&"
import style0 from "./EnterPasswordResetCode.vue?vue&type=style&index=0&id=04897481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04897481",
  null
  
)

export default component.exports